export default __webpack_public_path__ + "static/media/6.d50bc6f1.md";